import { StateCreator } from "zustand";

export interface YourDetailsSlice {
  firstName: string;
  lastName: string;
  email: string;
  termsAndConditionsAccepted: boolean;
  updateFirstName: (firstName: string) => void;
  updateLastName: (lastName: string) => void;
  updateEmail: (email: string) => void;
  updateTermsAndConditionsAccepted: (
    termsAndConditionsAccepted: boolean,
  ) => void;
  resetYourDetails: () => void;
}

export const createYourDetailsSlice: StateCreator<
  YourDetailsSlice,
  [],
  [],
  YourDetailsSlice
> = (set) => ({
  firstName: "",
  lastName: "",
  email: "",
  termsAndConditionsAccepted: false,
  updateFirstName: (firstName) => set(() => ({ firstName })),
  updateLastName: (lastName) => set(() => ({ lastName })),
  updateEmail: (email) => set(() => ({ email })),
  updateTermsAndConditionsAccepted: (termsAndConditionsAccepted) =>
    set(() => ({ termsAndConditionsAccepted })),
  resetYourDetails: () =>
    set(() => ({
      firstName: "",
      lastName: "",
      email: "",
    })),
});
